<template lang="html">
  <div class="">
    <div class="flex flex-row flex-wrap">
      <div v-if="stadiumInfo" class="w-full xs:w-1/3 lg:w-1/4">
        <div class="mb-6">
          <!-- <label class="text-sm">Stadium</label> -->
          <div class="flex justify-between">
            <div class="flex flex-col -mt-3 w-full xs:w-auto items-center xs:items-start">
              <img :src="stadiumInfo.avatar" class="rounded-full h-20 xs:h-24 md:h-32 w-20 xs:w-24 md:w-32 inline-block border border-rspurple p-1 object-cover"/>
              <div class="">
                <!-- <div class="flex justify-center">
                  <div class="text-sm mt-3 leading-none">{{ stadiumInfo.first_name }} {{stadiumInfo.last_name}}</div>
                </div>
 -->
                <div class="text-slategrey truncate-2 break-all">
                  {{ stadiumInfo.bio }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-full xs:w-2/3 lg:w-3/4">
        <div class="">
         <!--  <div class="">
            <input class="w-full fs-input px-4 py-2 rounded-xl" name="firstname" type="text" placeholder="First name*" v-model.trim="first_name" :class="{ 'is-invalid': $v.first_name.$error }">
            <span class="invalid-feedback" v-if="$v.first_name.$error && !$v.first_name.required">First name is required</span>
          </div>
 -->
          <div class="relative">
            <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill h-6 w-6 text-rspurple" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
            </div>
            <input class="w-full fs-input px-4 py-2 rounded-xl pl-10" name="firstname" type="text" placeholder="First name*" v-model.trim="first_name" :class="{ 'is-invalid': $v.first_name.$error }">
            <span class="invalid-feedback" v-if="$v.first_name.$error && !$v.first_name.required">First name is required</span>
          </div>

          <div class="relative">
            <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill h-6 w-6 text-rspurple" viewBox="0 0 16 16">
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
             </svg>
            </div>
             <input class="w-full fs-input px-4 py-2 rounded-xl pl-10" name="lastname" type="text" placeholder="Last name*" v-model.trim="last_name" :class="{ 'is-invalid': $v.last_name.$error }">
            <span class="invalid-feedback" v-if="$v.last_name.$error && !$v.last_name.required">Last name is required</span>
          </div>

          <!-- <div class="">
            <input class="w-full fs-input px-4 py-2 rounded-xl" name="lastname" type="text" placeholder="Last name*" v-model.trim="last_name" :class="{ 'is-invalid': $v.last_name.$error }">
            <span class="invalid-feedback" v-if="$v.last_name.$error && !$v.last_name.required">Last name is required</span>
          </div> -->
        </div>


        <div class="relative mb-4" v-if="stadiumInfo.phone_no_visible">
          <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone h-6 w-6 text-rspurple" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
            </svg>
          </div>
          <input class="w-full fs-input px-4  py-2 rounded-xl pl-10" name="phone_number" type="text" placeholder="Phone number*" v-model.trim="phone_number" :class="{ 'is-invalid': $v.phone_number.$error }">
          <span class="invalid-feedback" v-if="$v.phone_number.$error && !$v.phone_number.required">Phone number is required</span>
        </div>

        <div class="relative mb-4">
          <div class="flex absolute inset-y-0 left-0 items-center pl-3 mb-3">
            <svg aria-hidden="true" class="w-6 h-6 text-rspurple" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg>
          </div>
          <input class="w-full fs-input px-4  py-2 rounded-xl pl-10" name="email" type="text" placeholder="Email*" v-model.trim="email" :class="{ 'is-invalid': $v.email.$error }" readonly>
          <div v-if="$v.email.$error" class="invalid-feedback mt-1">
            <span v-if="!$v.email.required">Email is required</span>
            <span v-if="!$v.email.email">Email is invalid</span>
            <span v-if="!$v.email.isUnique">Email has already been taken</span>
          </div>
        </div>

        <div v-if="stadiumInfo.show_optional_fields">
          <select class="fs-input" v-model.trim="gender" required>
            <option value="" disabled selected class="text-lightgrey">Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="no_binary">Prefer not to say</option>
          </select>
        </div>

        <div class="">
          <label class="block text-sm text-white" for="birth_date">Date of Birth</label>

          <div class="w-full flex mt-2" v-if="stadiumInfo.show_optional_fields">
            <div class="relative">
              <select class="block appearance-none w-full border border-lightgrey bg-lightgrey py-3 px-4 pr-8 rounded-xl leading-tight focus:outline-none focus:bg-white" v-model="birth_month" @change="setDOB(true)">
                <option value="" disabled selected class="text-lightgrey">Month</option>
                <option value="01">January</option>
                <option value="02">February</option>
                <option value="03">March</option>
                <option value="04">April</option>
                <option value="05">May</option>
                <option value="06">June</option>
                <option value="07">July</option>
                <option value="08">August</option>
                <option value="09">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>

            <div class="relative mx-4">
              <select class="block appearance-none w-full bg-lightgrey border border-lightgrey py-3 px-4 pr-8 rounded-xl leading-tight focus:outline-none focus:bg-white" v-model="birth_day" @change="setDOB(true)">
                <option value="" disabled selected class="text-lightgrey">Day</option>
                <option :value="`${i}`" v-for="i in 31">{{ i }}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>

            <div class="relative">
              <select class="block appearance-none w-full bg-lightgrey border border-lightgrey py-3 px-4 pr-8 rounded-xl leading-tight focus:outline-none focus:bg-white" v-model="birth_year" @change="setDOB(true)">
                <option value="" disabled selected class="text-lightgrey">Year</option>
                <option :value="`${1900+i}`" v-for="i in 121">{{ 1900+i }}</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
          <span class="invalid-feedback mt-2" v-if="$v.birth_date.$error && !$v.birth_date.required">Date of Birth is Invalid</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { required, email, between, helpers, sameAs, requiredIf } from 'vuelidate/lib/validators';

  export default {
    props: {
      resource: Object,
      currentUser: Object,
      stadiumInfo: Object,
      stadium_code: String,
    },

    data() {
      return {
        first_name: this.stadiumInfo.first_name,
        last_name:  this.stadiumInfo.last_name,
        email: this.stadiumInfo.email,
        email_status: true,
        phone_number: this.stadiumInfo.phone_number,
        gender: this.stadiumInfo.gender,
        title: '',
        birth_date: '',
        birth_day: '',
        birth_month: '',
        birth_year: '',
        max_birth_year: '',
        min_birth_year: 1900,
        consent1: false,
        consent2: false,
        stadium_join_code: '',
      }
    },
    validations: {
      first_name: { required },
      last_name: { required },
      email: {
        required,
        email,
        isUnique(value) {
          if (value === '') return true

          return this.email_status;
        },
      },
      phone_number: {
        required: requiredIf(function () {
          return this.stadiumInfo.phone_no_visible == true
        })
      },
      gender: {
        required: requiredIf(function () {
          return this.stadiumInfo.show_optional_fields == true
        })
      },
      birth_year: {
        required: requiredIf(function () {
          return this.stadiumInfo.show_optional_fields == true
        })
      },
      birth_date: {
        required: requiredIf(function () {
          return this.stadiumInfo.show_optional_fields == true
        })
      },
      birth_day: {
        required: requiredIf(function () {
          return this.stadiumInfo.show_optional_fields == true
        })
      },
      birth_month: {
        required: requiredIf(function () {
          return this.stadiumInfo.show_optional_fields == true
        })
      },
  
      form: ['first_name', 'last_name', 'email', 'birth_day', 'birth_month', 'birth_year', 'birth_date', 'phone_number', 'gender'],
    },
    beforeMount(){
    },
    mounted(){
      if(this.resource){
        this.title = "Let's finish creating your account";
        this.first_name = this.resource.first_name;
        this.last_name = this.resource.last_name;
        this.email = this.resource.email;
        this.phone_number = this.resource.phone_number;
        this.gender = this.gender;
      }else{
        this.title = 'Create Your Account';
      }

      if(this.currentUser){
        var user_birth_date = this.currentUser.data.attributes.birth_date
        if(user_birth_date){
          this.birth_date = new Date(user_birth_date)
          this.birth_day = this.birth_date.getDate()
          this.birth_month = ('0' + this.birth_date.getMonth()).slice(-2)
          this.birth_year = this.birth_date.getFullYear()
          this.consent1 = true;
          this.consent2 = true;
        }
      }
    },
    methods: {
      validate() {
        // this.setDOB(false);
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid

        if (this.stadiumInfo.show_optional_fields == true && this.stadiumInfo.phone_no_visible == true){
          var data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            phone_number: this.phone_number,
            birth_date: this.birth_date,
            birth_day: this.birth_day,
            birth_month: this.birth_month,
            birth_year: this.birth_year,
            gender: this.gender,
          }
        }else if (this.stadiumInfo.show_optional_fields == true && this.stadiumInfo.phone_no_visible == false){
          var data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            birth_date: this.birth_date,
            birth_day: this.birth_day,
            birth_month: this.birth_month,
            birth_year: this.birth_year,
            gender: this.gender,
          }
        }else if (this.stadiumInfo.phone_no_visible == true && this.stadiumInfo.show_optional_fields == false){
          var data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            phone_number: this.phone_number,
          }
        }else{
          var data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
          }  
        }
        
        this.$emit('on-validate', data, isValid)
        return isValid
      },
      openSigninPage(){
        window.location = '/users/login';
      },
      validateUserEmail(){
        axios({
          method: 'post',
          headers: {
            "Accept": 'application/vnd.reset+json;version=1',
            "X-CSRF-Token": document.getElementsByName('csrf-token')[0].getAttribute('content')
          },
          url: '/api/users/validate_email',
          data: {
            email: this.email,
          }
        }).then((response) => {
          this.email_status = response.data.available;
        })
        .catch((error) => {
          this.email_status = error.response.data.available;
        });
      },
      // setDOB(flag) {
      //   var isValidDate = this.getDate().isValid();
      //   if(isValidDate && this.birth_day && this.birth_month && this.birth_year && this.birth_day <= 31 && this.birth_day >= 1 && parseInt(this.birth_month) >= 1 && parseInt(this.birth_month) <= 13 && parseInt(this.birth_year) <= new Date().getFullYear()){
      //     this.birth_date = new Date(this.birth_year, parseInt(this.birth_month)-1, this.birth_day)
      //   }else {
      //     this.birth_date = ''
      //   }
      // },

      setDOB(flag) {
        if(this.birth_day && this.birth_month && this.birth_year && this.birth_day <= 31 && this.birth_day >= 1 && parseInt(this.birth_month) >= 1 && parseInt(this.birth_month) <= 13 && parseInt(this.birth_year) <= new Date().getFullYear()){
          this.birth_date = new Date(this.birth_year, parseInt(this.birth_month)-1, this.birth_day)
        }else {
          this.birth_date = ''
        }
      },
      getDate(){
        var dateFormat = 'YYYY-MM-DD';
        var date = `${this.birth_year}-${this.birth_month}-${this.birth_day}`
        return this.$moment(this.$moment(date).format(dateFormat), dateFormat, true)
      },

      // fetchStadiumInfo(){
      //   if(this.stadium_join_code.length == 7){
      //     this.$parent.$parent.$parent.stadium_code = this.stadium_join_code;
      //     this.$parent.$parent.$parent.getStadiumInfo();
      //   }else{
      //     this.$parent.$parent.$parent.stadium_code = null;
      //     this.$parent.$parent.$parent.stadiumInfo = null;
      //   }
      // },
    }
  };
</script>

<style scoped>
.form-grid-cols{
  //grid-template-columns: 60% 40%;
}

option[value=""][disabled] {
  display: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>

<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  font-size: 80%;
  color: #dc3545;
}
</style>